import { Trailer } from '../../../../subPages/trailers/models/Trailer';
import { AssetStatus } from '../../../../common/Ui/StatusComponent/StatusComponent';
import { Box } from '@mui/material';

export const renderCustomTitle = (data: Trailer) => (
  <Box ml={1}>
    <AssetStatus status={data.status} />
  </Box>
);
